import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "影视资讯", to: "/category/资讯" },
  { label: "电视剧", to: "/category/电视剧" },
  { label: "电影", to: "/category/电影" },
  { label: "专题", to: "/category/资讯" },
  { label: "关于唐心", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMobileOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled
          ? "bg-background-50/95 border-background-200 backdrop-blur"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="flex h-16 items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-700 text-lg font-bold text-background-50 font-heading">
            唐
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-lg font-bold tracking-wide text-foreground-950 font-heading">
              唐心
            </span>
            <span className="font-label text-[10px] tracking-[0.25em] text-foreground-400">
              TANGXIN
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 ml-6">
          {navItems.map((item) => {
            const active =
              location.pathname === item.to ||
              (item.to !== "/about" &&
                location.pathname.startsWith("/category") &&
                decodeURIComponent(location.pathname) ===
                  decodeURIComponent(item.to));
            return (
              <Link
                key={item.label}
                to={item.to}
                className={`rounded-md px-3.5 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  active
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <form
          onSubmit={submitSearch}
          className="ml-auto hidden md:flex items-center gap-2 rounded-full bg-background-100 px-3 py-1.5 ring-1 ring-background-200 focus-within:ring-primary-300 transition-all"
        >
          <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
            <i className="ri-search-line text-base"></i>
          </span>
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索影视、剧集、资讯"
            className="w-40 lg:w-56 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50 hover:bg-primary-700 transition-colors cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="打开菜单"
          className="ml-auto md:hidden flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {mobileOpen ? (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-4 animate-fade-in">
          <form
            onSubmit={submitSearch}
            className="flex items-center gap-2 rounded-full bg-background-100 px-3 py-2 ring-1 ring-background-200"
          >
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视、剧集、资讯"
              className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-600 px-3 py-1 text-xs font-medium text-background-50 cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="mt-3 grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="rounded-md bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}